<template>
<div class="movieparent">
    <div  v-for='(key, value) in movies' v-bind:key="key.name" class="moviebar " v-on:click="setVideo($event)" >
        <span class="" :data-src="value">{{key.name}}</span>
    </div>
</div>
</template>

<style scoped>

.movieparent{
  margin-top: 10vh;
  overflow:scroll;
  direction: rtl;
  overflow-x: hidden;
  margin-left:-18px;
  height:80vh;
}

.moviebar{
  width:100%;
  line-height: 24px;
}

.moviebar span{
  cursor: pointer;
  margin-top:10px;
  font-size: 13px;
  font-weight: 700;
  background-color: rgba(0, 0, 0, 0.25);
  color:rgb(255, 255, 255);
  display: block;
  font-family: 'Lato', sans-serif;
  padding-top:4px;
  padding-bottom:4px;
  width:200px;
  text-align: center;
}

@media (orientation:portrait){
  .movieparent{
    display:flex;
    flex-wrap: wrap;
    margin-top:0px;
    margin-left:0px;
    justify-content:center;
    height:auto;
    direction:ltr;
    text-align: center;
  }
  .movieparent span{
    flex-grow: 1;
    display:inline-block;
    width:175px;
    margin-left:5px;
    margin-right:5px;
  }
  .moviebar{
    width: auto;
    text-align:center;
  }
}

@media (orientation: landscape) and (max-width:981px){

.movieparent{
  margin-top: 0;
  height:95vh;
}

.moviebar span{
  font-size: 12px;
  word-wrap: break-word;
  font-weight: 400;
  padding-top:3px;
  padding-bottom:3px;
  width:120px;
  text-align: center;
}

}

</style>

<script>
import s1data from '../../json/assistenzhunde.json'
export default {
  name: 'AHnav',
  data () {
    return {
      movies: s1data
    }
  },
  methods: {
    setVideo: function ($event) {
      // Setzt das video vom Player anhand des Elements das geklickt wird.
      document.getElementsByTagName('video')[0].src = '/videos/Assistenzhunde/' + s1data[$event.target.dataset.src].url
      document.getElementsByTagName('video')[0].play()
    }
  },
  props: {
    msg: String
  }
}
</script>
